import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { ReplySalaryChangeRequestResponse } from 'api/laborerPortalAPI/authContract'
import { replyLaborerSalaryChangeRequest } from 'redux/actionCreators/laborerPortalAPI/authContract'

type State = {
  reply?: ReturnType<typeof replyLaborerSalaryChangeRequest>['payload']['params']['reply']
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  reply: undefined,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_ASYNC,
    Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_SUCCESS,
    Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_FAIL,
    ReplySalaryChangeRequestResponse,
    {},
    {},
    ReturnType<typeof replyLaborerSalaryChangeRequest>['payload']
  >,
): State => {
  switch (action.type) {
    case Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_ASYNC: {
      const { callAPIActionPayload } = action
      return {
        ...state,
        ...action.status,
        reply: callAPIActionPayload.params.reply,
      }
    }
    case Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_SUCCESS:
    case Actions.REPLY_LABORER_SALARY_CHANGE_REQUEST_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
